import { DefaultWeakMap } from '@/utils/DefaultMap'

const cancelers = new DefaultWeakMap(() => new Map())

export default {
  methods: {
    runDelayed(name, fn, delay) {
      let launch, cancel
      if (delay === 'frame') {
        launch = requestAnimationFrame
        cancel = cancelAnimationFrame
      } else {
        launch = fn => setTimeout(() => fn(), delay)
        cancel = clearTimeout
      }

      this.cancelDelayed(name)

      const launchResult = launch(() => {
        cancelers.get(this).delete(name)
        fn.call(this)
      })
      cancelers.get(this).set(name, () => cancel(launchResult))
    },

    cancelDelayed(name) {
      const canceler = cancelers.get(this).get(name)
      if (canceler) {
        canceler()
        cancelers.get(this).delete(name)
      }
    },

    hasDelayed(name) {
      return Boolean(cancelers.get(this).get(name))
    },
  },

  beforeDestroy() {
    for (const canceler of cancelers.get(this).values()) canceler()
  },
}
